import { Layout } from 'antd'
import Styled from 'styled-components'

const { Footer } = Layout

const S = {}

S.Footer = Styled(Footer)`
    text-align: center;
    box-shadow: 0px -5px 20px #c9d6dc;
    background: rgb(232 232 233);
`

export default S
